import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import publicClient from '../../api/publicClient';

function AccountActivationPage() {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const rawToken = window.location.hash.slice(1);
    setToken(rawToken);
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!token) {
      setError('Aktivierungslink ist ungültig oder unvollständig.');
      return;
    }
    if (password.length < 12 || password.length > 72) {
      setError('Passwort muss zwischen 12 und 72 Zeichen lang sein.');
      return;
    }
    if (password !== confirmation) {
      setError('Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);
    try {
      await publicClient.post('/api/auth/activate-account', { token, password });
      navigate('/login', { replace: true, state: { passwordSet: true } });
    } catch (requestError) {
      setError(requestError.response?.data?.error || 'Konto konnte nicht aktiviert werden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ width: '100%', maxWidth: 460 }}>
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack spacing={3}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Passwort festlegen
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Legen Sie ein Passwort fest, um Ihr Konto zu aktivieren oder wieder freizuschalten.
          </Typography>
          {error && <Alert severity="error">{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <Stack spacing={2.5}>
              <TextField
                label="Passwort"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                helperText="12 bis 72 Zeichen; Passphrasen und Leerzeichen sind erlaubt"
                disabled={loading}
                autoFocus
                fullWidth
              />
              <TextField
                label="Passwort wiederholen"
                type="password"
                value={confirmation}
                onChange={(event) => setConfirmation(event.target.value)}
                disabled={loading}
                fullWidth
              />
              <Button type="submit" variant="contained" size="large" disabled={loading || !token}>
                {loading ? 'Passwort wird gespeichert...' : 'Passwort speichern'}
              </Button>
            </Stack>
          </form>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default AccountActivationPage;